import React from "react";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";
import "./Officers.css";
import Emily from "../imgs/Emily.JPG";
import Sydni from "../imgs/Sydni.JPG";
import Esha from "../imgs/esha.jpg";
import Tyla from "../imgs/tyla.JPG";
import Kate from "../imgs/kate.JPG"
import Gaya from "../imgs/gaya.JPG";
import Aily from "../imgs/Aily.JPG";
import Charley from "../imgs/charley.JPG";
import Samantha_H from "../imgs/samantha_h.JPG";
import Ananya from "../imgs/ananya.JPG";
import Sally from "../imgs/sally.JPG";
import Jenny from "../imgs/jenny.JPG";
import Neha from "../imgs/neha.JPG"
import Rhea from "../imgs/rhea.jpg"
import Marwa from "../imgs/marwa.JPG"
import Samantha_W from "../imgs/samantha_w.JPG"
import Dana from "../imgs/dana.JPG"
import Madison from "../imgs/madison.jpg"
//import { typeImplementation } from "@testing-library/user-event/dist/type/typeImplementation";
//import { typographyClasses } from "@mui/material";

const Officers = () => {
  return (
    <div className="home">
      <div className="blackText">
        <div className="navbarSpace"></div>
        <div className="header-title">Executive Board</div>
      </div>

      <div className="row-container">
        <div className="officer-container">
          <div className="subtitles">President</div>
          <div className="circle-container">
            <img className="circle_pic" src={Emily} alt="President" />
          </div>
          <div className="subtitles">Emily D'Alessandro</div>
          <div className="info">Electrical Engineering</div>
          <div className="info">Senior</div>
          <div className="infoLinks">
            <LinkedInIcon style={{ width: '3vw', height: '3vw' }} onClick={() => window.open("https://www.linkedin.com/in/emily-d-alessandro-4242622a4")} />
            <EmailIcon style={{ width: '3vw', height: '3vw' }} onClick={() => (window.location = "mailto:president.wece@gmail.com")} />
          </div>
        </div>

        <div className="officer-container">
          <div className="subtitles">VP Internal</div>
          <div className="circle-container">
            <img className="circle_pic" src={Sydni} alt="VP Internal" />
          </div>
          <div className="subtitles">Sydni-Noel Levy-Davis</div>
          <div className="info">Computer Engineering</div>
          <div className="info">Senior</div>
          <div className="infoLinks">
            <LinkedInIcon style={{ width: '3vw', height: '3vw' }} onClick={() => window.open("https://www.linkedin.com/in/sdlevydavis")} />
            <EmailIcon style={{ width: '3vw', height: '3vw' }} onClick={() => (window.location = "mailto:vpinternal.wece@gmail.com")} />
          </div>
        </div>

        <div className="officer-container">
          <div className="subtitles">VP External</div>
          <div className="circle-container">
            <img className="circle_pic" src={Esha} alt="VP External" />
          </div>
          <div className="subtitles">Esha Patel</div>
          <div className="info">Computer Science</div>
          <div className="info">Sophomore</div>
          <div className="infoLinks">
            <LinkedInIcon style={{ width: '3vw', height: '3vw' }} onClick={() => window.open("https://www.linkedin.com/in/esha-m-patel")} />
            <EmailIcon style={{ width: '3vw', height: '3vw' }} onClick={() => (window.location = "mailto:vpexternal.wece@gmail.com")} />
          </div>
        </div>
      </div>

      <div className="row-container">
        <div className="officer-container">
          <div className="subtitles">Secretary</div>
          <div className="circle-container">
            <img className="circle_pic" src={Tyla} alt="Secretary" />
          </div>
          <div className="subtitles">Tyla Hart</div>
          <div className="info">Computer Engineering</div>
          <div className="info">Senior</div>
          <div className="infoLinks">
            <LinkedInIcon style={{ width: '3vw', height: '3vw' }} onClick={() => window.open("https://www.linkedin.com/in/tyla-hart")} />
            <EmailIcon style={{ width: '3vw', height: '3vw' }} onClick={() => (window.location = "mailto:secretary.wece@gmail.com")} />
          </div>
        </div>

        <div className="officer-container">
          <div className="subtitles">Treasurer</div>
          <div className="circle-container">
            <img className="circle_pic" src={Kate} alt="Treasurer" />
          </div>
          <div className="subtitles">Kate Thompson</div>
          <div className="info">Electrical Engineering</div>
          <div className="info">Sophomore</div>
          <div className="infoLinks">
            <LinkedInIcon style={{ width: '3vw', height: '3vw' }} onClick={() => window.open("https://www.linkedin.com/in/kate-thompson-98a71027b")} />
            <EmailIcon style={{ width: '3vw', height: '3vw' }} onClick={() => (window.location = "mailto:treasurer.wece@gmail.com")} />
          </div>
        </div>
      </div>

      <div className="blackText">
       <div className="header-title">Officers</div>
      </div>
      <div className="row-container">
       <div className="officer-container">
          <div className="subtitles">Curriculum Chair</div>
          <div className="circle-container">
            <img
              className="circle_pic" src={Gaya} alt="CpE Curriculum Chair"
            />
          </div>
          <div className="subtitles">Gaya Baskaran</div>
          <div className="info">Computer Engineering</div>
          <div className="info">Senior</div>
          <div className="infoLinks">
            <LinkedInIcon style={{ width: '3vw', height: '3vw' }} onClick={() => window.open("https://www.linkedin.com/in/gayatri-baskaran/")} />
            <EmailIcon style={{ width: '3vw', height: '3vw' }} onClick={() => (window.location = "mailto:curriculum.wece@gmail.com")} />
          </div>
        </div> 

        <div className="officer-container">
          <div className="subtitles">Event Coordinator</div>
          <div className="circle-container">
            <img className="circle_pic" src={Aily} alt="Event Coordinator" />
          </div>
          <div className="subtitles">Aily Mai</div>
          <div className="info">Computer Engineering</div>
          <div className="info">Junior</div>
          <div className="infoLinks">
            <LinkedInIcon style={{ width: '3vw', height: '3vw' }} onClick={() => window.open("https://www.linkedin.com/in/aily-mai")} />
            <EmailIcon style={{ width: '3vw', height: '3vw' }} onClick={() => (window.location = "mailto:eventcoordinator.wece@gmail.com")} />
          </div>
        </div>

        <div className="officer-container">
          <div className="subtitles">Event Coordinator</div>
          <div className="circle-container">
            <img className="circle_pic" src={Charley} alt="Event Coordinator" />
          </div>
          <div className="subtitles">Charley Kennedy</div>
          <div className="info">Computer Engineering </div>
          <div className="info">Sophomore</div>
          <div className="infoLinks">
            <LinkedInIcon style={{ width: '3vw', height: '3vw' }} onClick={() => window.open("https://www.linkedin.com/in/charley-g-kennedy/")} />
            <EmailIcon style={{ width: '3vw', height: '3vw' }} onClick={() => (window.location = "mailto:eventcoordinator.wece@gmail.com")} />
          </div>
        </div>
      </div>

      <div className="row-container">
      <div className="officer-container">
          <div className="subtitles">Membership Coordinator</div>
          <div className="circle-container">
            <img className="circle_pic" src={Samantha_H} alt="Membership Coordinator" />
          </div>
          <div className="subtitles">Samantha Handyside</div>
          <div className="info">Computer Engineering</div>
          <div className="info">Sophomore</div>
          <div className="infoLinks">
            <LinkedInIcon style={{ width: '3vw', height: '3vw' }} onClick={() => window.open("https://www.linkedin.com/in/samanthahandyside/")} />
            <EmailIcon style={{ width: '3vw', height: '3vw' }} onClick={() => (window.location = "mailto:eventcoordinator.wece@gmail.com")} />
          </div>
        </div>

        <div className="officer-container">
          <div className="subtitles">Tech Workshop Chair</div>
          <div className="circle-container">
            <img className="circle_pic" src={Ananya} alt="Tech Workshop Chair" />
          </div>
          <div className="subtitles">Ananya Balla</div>
          <div className="info">Computer Engineering</div>
          <div className="info">Sophomore</div>
          <div className="infoLinks">
            <LinkedInIcon style={{ width: '3vw', height: '3vw' }} onClick={() => window.open("https://www.linkedin.com/in/ananya-balla")} />
            <EmailIcon style={{ width: '3vw', height: '3vw' }} onClick={() => (window.location = "mailto:workshops.wece@gmail.com")} />
          </div>
        </div>

        <div className="officer-container">
          <div className="subtitles">Tech Workshop Chair</div>
          <div className="circle-container">
            <img className="circle_pic" src={Sally} alt="Tech Workshop Chair" />
          </div>
          <div className="subtitles">Sally Golding</div>
          <div className="info">Computer Engineering</div>
          <div className="info">Senior</div>
          <div className="infoLinks">
            <LinkedInIcon style={{ width: '3vw', height: '3vw' }} onClick={() => window.open("https://www.linkedin.com/in/sally-golding-4584a8291")} />
            <EmailIcon style={{ width: '3vw', height: '3vw' }} onClick={() => (window.location = "mailto:workshops.wece@gmail.com")} />
          </div>
        </div>
      </div>
      
      <div className="row-container">
        <div className="officer-container">
          <div className="subtitles">PR Chair</div>
          <div className="circle-container">
            <img
              className="circle_pic" src={Jenny} alt="PR Chair"
            />
          </div>
          <div className="subtitles">Jenny Kim</div>
          <div className="info">Electrical Engineering</div>
          <div className="info">Senior</div>
          <div className="infoLinks">
            <LinkedInIcon style={{ width: '3vw', height: '3vw' }} onClick={() => window.open("http://www.linkedin.com/in/jennykim5")} />
            <EmailIcon style={{ width: '3vw', height: '3vw' }} onClick={() => (window.location = "mailto:mentorship.wece@gmail.com")} />
          </div>
        </div>

        <div className="officer-container">
          <div className="subtitles">New Member Liaison</div>
          <div className="circle-container">
            <img
              className="circle_pic" src={Neha} alt="New Member Liaison"/>
          </div>
          <div className="subtitles">Neha Jupalli</div>
          <div className="info">Data Science</div>
          <div className="info">Sophomore</div>
          <div className="infoLinks">
            <LinkedInIcon style={{ width: '3vw', height: '3vw' }} onClick={() => window.open("https://www.linkedin.com/in/neha-jupalli/")} />
            <EmailIcon style={{ width: '3vw', height: '3vw' }} onClick={() => (window.location = "mailto:Trinity.saunders@ufl.edu")} />
          </div>
        </div>

        <div className="officer-container">
          <div className="subtitles">Corporate Liaison</div>
          <div className="circle-container">
            <img className="circle_pic" src={Rhea} alt="Corporate Liaison" />
          </div>
          <div className="subtitles">Rhea Gaudi</div>
          <div className="info">Electrical Engineering </div>
          <div className="info">Sophomore</div>
          <div className="infoLinks">
            <LinkedInIcon style={{ width: '3vw', height: '3vw' }} onClick={() => window.open("https://www.linkedin.com/in/rheagaudiuf")} />
            <EmailIcon style={{ width: '3vw', height: '3vw' }} onClick={() => (window.location = "mailto:corporateliaison.wece@gmail.com")} />
          </div>
        </div>
      </div>

      <div className="row-container">
      <div className="officer-container">
          <div className="subtitles">Outreach Coordinator</div>
          <div className="circle-container">
            <img className="circle_pic" src={Marwa} alt="Outreach Coordinator" />
          </div>
          <div className="subtitles">Marwa Khan</div>
          <div className="info">Electrical Engineering</div>
          <div className="info">Junior</div>
          <div className="infoLinks">
            <LinkedInIcon style={{ width: '3vw', height: '3vw' }} onClick={() => window.open("https://www.linkedin.com/in/marwa-khan-1064682b5/")} />
            <EmailIcon style={{ width: '3vw', height: '3vw' }} onClick={() => (window.location = "mailto:outreach.wece@gmail.com")} />
          </div>
        </div>

        <div className="officer-container">
          <div className="subtitles">Historian</div>
          <div className="circle-container">
            <img className="circle_pic" src={Samantha_W} alt="Historian" />
          </div>
          <div className="subtitles">Samantha Walsh</div>
          <div className="info">Computer Engineering</div>
          <div className="info">Sophomore</div>
          <div className="infoLinks">
            <LinkedInIcon style={{ width: '3vw', height: '3vw' }} onClick={() => window.open("https://www.linkedin.com/in/samantha-r-walsh")} />
            <EmailIcon style={{ width: '3vw', height: '3vw' }} onClick={() => (window.location = "mailto:outreach.wece@gmail.com")} />
          </div>
        </div>

        <div className="officer-container">
          <div className="subtitles">Webmaster</div>
          <div className="circle-container">
            <img className="circle_pic" src={Dana} alt="Webmaster" />
          </div>
          <div className="subtitles">Dana Moreno</div>
          <div className="info">Electrical Engineering</div>
          <div className="info">Senior</div>
          <div className="infoLinks">
            <LinkedInIcon style={{ width: '3vw', height: '3vw' }} onClick={() => window.open("https://www.linkedin.com/in/dana-moreno-9931621bb")} />
            <EmailIcon style={{ width: '3vw', height: '3vw' }} onClick={() => (window.location = "mailto:webmaster.wece@gmail.com")} />
          </div>
        </div>
      </div>
        

      <div className="row-container">
        <div className="officer-container">
          <div className="subtitles">Webmaster</div>
          <div className="circle-container">
            <img className="circle_pic" src={Madison} alt="Webmaster" />
          </div>
          <div className="subtitles">Madison Pock</div>
          <div className="info">Electrical Engineering</div>
          <div className="info">Sophomore</div>
          <div className="infoLinks">
            <LinkedInIcon style={{ width: '3vw', height: '3vw' }} 
              onClick={() => window.open("https://www.linkedin.com/in/madison-pock-735a4027a")} />
            <EmailIcon style={{ width: '3vw', height: '3vw' }} 
              onClick={() => (window.location = "mailto:webmaster.wece@gmail.com")} />
          </div>
        </div>
      </div>   
    </div>    
  );
};


export default Officers;
